import { template } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import { Col, RowIndented } from 'styles/components/layout'
import { Text, H2 } from 'styles/components/typography'

import {
  Container,
  IconWrapper,
  Article,
  BoxBaseStyled,
  TextWrapper,
} from './styles'

/**
 * CartDeliveryInfo
 *
 * @param {object} props - properties of component
 * @returns {node} CartDeliveryInfo
 */
const CartDeliveryInfo = props => {
  const { deliveryConfig, deliveryTexts, isLoading } = props
  const compileTitle = template(deliveryTexts.title)
  const placeholder = isLoading && '...'
  const title = compileTitle({
    from: placeholder || deliveryConfig.from,
    to: placeholder || deliveryConfig.to,
  })
  const compileContent = template(deliveryTexts.content_note)
  const content = compileContent({
    from: placeholder || deliveryConfig.from,
    to: placeholder || deliveryConfig.to,
  })

  return (
    <SectionWrapper isWideToDesktop={true}>
      <BoxBaseStyled>
        <RowIndented indent={{ xs: 0, md: 0, lg: 0 }} justifyContent="center">
          <Col width={{ xs: 1, lg: 8 / 12 }}>
            <Container>
              <IconWrapper>
                <Icon id="color_courier" />
              </IconWrapper>
              <TextWrapper>
                <Article>
                  <H2 as="h3" dangerouslySetInnerHTML={{ __html: title }} />
                  <Text dangerouslySetInnerHTML={{ __html: content }} />
                </Article>
              </TextWrapper>
            </Container>
          </Col>
        </RowIndented>
      </BoxBaseStyled>
    </SectionWrapper>
  )
}

CartDeliveryInfo.propTypes = {
  /** Determines if delivery timings is loading **/
  isLoading: PropTypes.bool.isRequired,

  /** Object with delivery configuration */
  deliveryConfig: PropTypes.object.isRequired,

  /** Localized texts */
  deliveryTexts: PropTypes.object.isRequired,
}

CartDeliveryInfo.defaultProps = {}

export default CartDeliveryInfo
